import { animate, animation, state, style, transition, trigger, useAnimation } from '@angular/animations'

export const smoothCollapseAnimation = animation([
  animate('{{ time }}')
])

export const triggerSmoothCollapseAnimation = trigger('smoothCollapse', [
  state('initial', style({ height: '0', overflow: 'hidden', opacity: '0', visibility: 'hidden', display: 'none' })),
  state('final', style({ overflow: 'hidden' })),
  transition('initial <=> final', useAnimation(smoothCollapseAnimation, { params: { time: '300ms' } }))
])

export const triggerSmoothFacetsCollapseAnimation = trigger('smoothFacetsCollapse', [
  state('initial', style({ height: '2.5rem', display: 'block' })),
  state('final', style({ height: '*', display: 'block' })),
  transition('initial <=> final', useAnimation(smoothCollapseAnimation, { params: { time: '300ms' } })),
])
